import * as complextext from './complex-text/complex-text-widget';
import * as text from './text/text-widget';
import * as image from './image/image-widget';
import * as lottie from './lottie/lottie-widget';
import * as video from './video/video-widget';
import * as countdown from './countdown/countdown-widget';
import * as poll from './poll/poll-widget';
import * as transactionList from './transaction-list/transaction-list-widget';
import * as customWidget from './custom/custom-widget';

export default function availableWidgets() {
  return {
    ...createWidgetWrapper(text),
    ...createWidgetWrapper(complextext),
    ...createWidgetWrapper(image),
    ...createWidgetWrapper(lottie),
    ...createWidgetWrapper(video),
    ...createWidgetWrapper(countdown),
    ...createWidgetWrapper(poll),
    ...createWidgetWrapper(transactionList),
    ...createWidgetWrapper(customWidget),
  };
}

function createWidgetWrapper(widget) {
  return {
    [widget.type]: {
      view: widget.view,
      editor: widget.editor,
      builder: widget.builder,
    },
  };
}
